import { render, staticRenderFns } from "./LightingEnergy.vue?vue&type=template&id=61208040&scoped=true"
import script from "./LightingEnergy.vue?vue&type=script&lang=js"
export * from "./LightingEnergy.vue?vue&type=script&lang=js"
import style0 from "./LightingEnergy.vue?vue&type=style&index=0&id=61208040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61208040",
  null
  
)

export default component.exports